const ImageCaption = ({caption, theme}) => {
    return(
    <div className='image-caption-wrapper'>
        <div className='image-caption '>{caption}</div>
        {
            theme === 'dark' ? 
            <>
                <div className="corner-bottom-right top">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 0L0 20C0 8.95431 8.95431 0 20 0L0 0Z" fill="black"></path>
                    </svg>
                </div>
                <div className="corner-bottom-right bottom">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 0L0 20C0 8.95431 8.95431 0 20 0L0 0Z" fill="black"></path>
                    </svg>
                </div>
            </> :
            <>
                 <div className="corner-bottom-right top">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 0L0 20C0 8.95431 8.95431 0 20 0L0 0Z" fill="white"></path>
                    </svg>
                </div>
                <div className="corner-bottom-right bottom">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 0L0 20C0 8.95431 8.95431 0 20 0L0 0Z" fill="white"></path>
                    </svg>
                </div>
            </>
        }
    </div>
    )
}

export default ImageCaption;